import React, { Component } from 'react';
import AOForm from '../../../shared/AOForm';
import '../style/SelectCountry.css';

export default class SelectCountry extends Component {
    constructor(props) {
        super();
        this.state = {
            selectValue: props.content.countryCode_options[0].text,
            countryCode: props.content.countryCode_options[0].countryCode
        };
        [
            'onDidChange',
            'getValue',
            'getCountryCode'
        ].forEach((fn) => this[fn] = this[fn].bind(this));
    }
    componentDidMount() {
    }
    onDidChange = (value, event) => {
        const { content } = this.props;
        const itemTmp = content.countryCode_options.filter(item => (item.text === value));
        this.props.changeValEvt(itemTmp[0].id);
        this.setState({
            countryCode: itemTmp[0].countryCode,
            selectValue: value
        });
    }
    getCountryCode() {
        return this.state.countryCode;
    }
    getValue() {
        return this.state.selectValue.replace(/\+/g, "");
    }
    render() {
        const { content } = this.props;
        const { selectValue } = this.state;
        return (
            <div className={"logon-country-body"}>
                <AOForm.Select
                    content={{
                        selectOptions: content.countryCode_options.map(key => {
                            return ({id: key.text, text: key.text, dataKey: key.id})
                        }),
                        defaultValue: selectValue,
                        itemTitle:{
                            text: content.countryCode,
                            dataKey: 'countryCode'
                        },
                        dataKey: 'countryCode'
                    }}
                    onChangeAction={ (questionRel, value, event) => this.onDidChange(value, event) }
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/Logon/components/SelectCountry.js